import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { skinBaseUrl } from "network";

export const scanSlice = createApi({
  reducerPath: "scanSlice",
  baseQuery: fetchBaseQuery({
    baseUrl: skinBaseUrl,
    credentials: "include",
    prepareHeaders: (headers, { getState }) => {
      const state = getState();
      const token = state.auth?.token;
      if (token) {
        console.log("token", token);
        headers.set("authorization", `Bearer ${token}`);
      } else {
        console.warn("Token not found in state.auth");
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getScans: builder.query({
      query: ({ page = 1, limit = 10, search = "" }) => ({
        url: `/scan?page=${page}&limit=${limit}&search=${search}`,
        method: "GET",
      }),
      transformResponse: (response) => response,
    }),

    getScanReport: builder.query({
      query: (id) => ({
        url: `/scan/${id}`,
        method: "GET",
      }),
    }),

    // // ✅ Add New Location
    // addOffers: builder.mutation({
    //     query: (body) => ({
    //         url: "/offer",
    //         method: "POST",
    //         body,
    //     }),
    // }),

    // // ✅ Update Existing Category
    // updateOffer: builder.mutation({
    //     query: ({ id, body }) => ({
    //         url: `/offer/${id}`,
    //         method: "PUT",
    //         body,
    //     }),
    // }),

    // ✅ Delete Category
    deleteScan: builder.mutation({
      query: (id) => ({
        url: `/offer/${id}`,
        method: "DELETE",
      }),
    }),

    getSkinAiCharges: builder.query({
      query: () => ({
        url: `https://betaapi.madamg.ai/api/backend/v1/beauty/setting/skinPrice`,
        method: "GET",
      }),
      transformResponse: (response) => response.data,
    }),

    updateSkinAiCharges: builder.mutation({
      query: (skinAiCharges) => ({
        url: `https://betaapi.madamg.ai/api/backend/v1/beauty/setting/sikinPriceUpdate`,
        method: "PUT",
        body: { skinAiCharges },
      }),
    }),

    //

    // getTypeSubCat: builder.query({
    //     query: ({ selectedCategory = "" }) => ({
    //         url: `/category?type=${selectedCategory}`,
    //         method: "GET",
    //     }),
    //     transformResponse: (response) => response,
    // }),
  }),
});

export const {
  useGetScansQuery,
  useGetScanReportQuery,
  useDeleteScanMutation,
  useGetSkinAiChargesQuery,
  useUpdateSkinAiChargesMutation,
} = scanSlice;
